import { EventEmitter } from "pixi.js";

export enum EnumEventBus {
  setCalcLines = "SET_CALC_LINES",
  showCalcLine = "SHOW_CALCULATION_LINE",
  setGrowCircleValue = "SET_GROW_CIRCLE_VALUE",
  setCentralValue = "SET_CENTRAL_SLIDER_VALUE",
  setRotCircleValue = "SET_ROTATE_CIRCLE_VALUE",
  setRadiansToRefs = "SET_RADIAN_PARAMS_TO_RADIAN_REFERANCE_PARAMS",
  setCalcForAnim = "SET_CALCULATION_LINE_FOR_ANIMATION",
  showSliders = "SHOW_SLIDERS",
  drawElements = "DRAW_ELEMENTS",
  generateRandomQuadri = "GENERATE_RANDOM_QUADRILATERAL",
  movePoints = "MOVE_POINTS",
  supplementaryMode = "SUPPLEMENTARY_MODE",
  setElementsForAnim = "SET_ELEMENTS_FOR_ANIMATION",
  setPointChecklist = "SET_POINT_CHECK_LIST"
}

export const EventBus = new EventEmitter();